/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridRow, GridColumn, Input, Button } from "arv-reactcomponents";
import { LISTING } from "npmlinks-constants";
import { ToCurrency, CurrencyToVal } from "../../../utils";

@inject("ProductStore", "CommonStore")
@observer
class PriceFilter extends Component {
  constructor() {
    super();
    this.state = {
      min: "",
      max: "",
      errorMessage: "",
    };
    this.timeoutVar = null;
    this.actionTimeout = null;
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.toggleMessage = this.toggleMessage.bind(this);
    this.mobileTrigger = this.mobileTrigger.bind(this);
    this.timerTrigger = this.timerTrigger.bind(this);
  }
  componentDidMount() {
    this.init(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.init(nextProps);
  }
  componentWillUnmount() {
    this.mobileTrigger();
  }
  get buttonDisabled() {
    const { min, max } = this.state;
    const { customPriceFilters = [] } = this.props.ProductStore;
    const [filter = {}] = customPriceFilters;
    const { min: custMin = "", max: custMax = "" } = filter;
    return (
      !(min && max) ||
      (parseInt(min, 10) === parseInt(custMin, 10) &&
        parseInt(max, 10) === parseInt(custMax, 10))
    );
  }
  init(props) {
    const { customPriceFilters } = props.ProductStore;
    const [value = {}] = customPriceFilters;
    const { min, max } = value;
    this.setState({ min, max });
  }
  handleSubmit(event, mobile) {
    if (event) {
      event.preventDefault();
    }
    const { min, max } = this.state;
    if (!min || !max) {
      if (!mobile) {
        this.toggleMessage(LISTING.PRICE_FILTER.ALL_BOXES);
      }
    } else if (min >= max) {
      if (!mobile) {
        this.toggleMessage(LISTING.PRICE_FILTER.GREATER);
      }
    } else if (!this.buttonDisabled) {
      this.props.customPriceFiltersApplied();
      this.props.onChange(
        {
          isSelected: false,
          displayName: `${ToCurrency(min)}-${ToCurrency(max)}`,
          value: `${min}-${max}`,
          mapping: this.props.mapping,
          filterType: "Price",
          min,
          max,
        },
        "customPriceFilters",
      );
    }
  }
  updateValue(event, type) {
    const { isDesktop } = this.props.CommonStore;
    const {
      target: { value: currency },
    } = event;
    const value = CurrencyToVal(currency);
    if (!value && !isNaN(value)) {
      this.setState({
        [type]: "",
      });
      this.toggleMessage(value === 0 ? LISTING.PRICE_FILTER.NO_ZERO_START : "");
    } else if (isNaN(value)) {
      this.setState({
        [type]: "",
      });
      this.toggleMessage(LISTING.PRICE_FILTER.NUMBERS_ONLY);
    } else if (value > LISTING.PRICE_FILTER.AMOUNT_LIMIT) {
      this.toggleMessage(LISTING.PRICE_FILTER.AMOUNT_LIMIT_ERROR);
    } else {
      this.toggleMessage("");
      this.setState({ [type]: value });
      if (!isDesktop) {
        this.timerTrigger();
      }
    }
  }
  mobileTrigger() {
    const { isDesktop } = this.props.CommonStore;
    if (!isDesktop) {
      this.handleSubmit(null, true);
    }
  }
  toggleMessage(message) {
    if (this.timeoutVar) {
      clearTimeout(this.timeoutVar);
    }
    this.setState({ errorMessage: message });
    this.timeoutVar = setTimeout(() => {
      this.setState({ errorMessage: "" });
    }, LISTING.PRICE_FILTER.ERROR_TIMEOUT);
  }
  timerTrigger() {
    if (this.actionTimeout) {
      clearTimeout(this.actionTimeout);
    }
    this.actionTimeout = setTimeout(() => {
      this.mobileTrigger();
    }, LISTING.PRICE_FILTER.KEYBOARD_INACTIVE_TIMEOUT);
  }
  render() {
    const { isDesktop } = this.props.CommonStore;
    const { min = "", max = "", errorMessage } = this.state;
    return (
      <form
        className="nw-listingpricefilter-container"
        onSubmit={this.handleSubmit}
      >
        <GridRow className="nw-listingpricefilter-row">
          <GridColumn
            className={`nw-listingpricefilter-inputcolumn nwc-grid-col-xs-${(isDesktop &&
              "4") ||
              "4"}`}
          >
            <Input
              placeholder={LISTING.PRICE_FILTER.PLACEHOLDERS.MIN}
              type="tel"
              className="nw-listingpricefilter-input min"
              value={(min && ToCurrency(min)) || ""}
              onChange={e => this.updateValue(e, "min")}
              onBlur={this.mobileTrigger}
            />
          </GridColumn>
          <GridColumn
            className={`nw-listingpricefilter-inputcolumn nw-listingpricefilter-hypen  nwc-grid-col-xs-${(isDesktop &&
              "1") ||
              "1"}`}
          >
            {LISTING.PRICE_FILTER.HYPHEN}
          </GridColumn>
          <GridColumn
            className={`nw-listingpricefilter-inputcolumn  nwc-grid-col-xs-${(isDesktop &&
              "4") ||
              "4"}`}
          >
            <Input
              type="tel"
              placeholder={LISTING.PRICE_FILTER.PLACEHOLDERS.MAX}
              className="nw-listingpricefilter-input max"
              value={(max && ToCurrency(max)) || ""}
              onChange={e => this.updateValue(e, "max")}
              onBlur={this.mobileTrigger}
            />
          </GridColumn>
          <GridColumn
            className={`nw-listingpricefilter-inputcolumn  nwc-grid-col-xs-nwc-grid-col-xs-${(isDesktop &&
              "3") ||
              "3"}`}
          >
            <Button
              className="nw-listingpricefilter-button"
              onClick={this.handleSubmit}
              disabled={this.buttonDisabled}
            >
              <i className="icomoon-arrow_right nw-listingpricefilter-buttonicon" />
            </Button>
          </GridColumn>
        </GridRow>
        <p className="nw-listingpricefilter-error">{errorMessage}</p>
      </form>
    );
  }
}
PriceFilter.wrappedComponent.propTypes = {
  customPriceFiltersApplied: PropTypes.func.isRequired,
  mapping: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ProductStore: PropTypes.shape({
    customPriceFilters: PropTypes.shape({}).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PriceFilter.wrappedComponent,
  component: PriceFilter,
};

export default ProjectComponent;
